import { render, staticRenderFns } from "./select_modules.vue?vue&type=template&id=006a90c8&scoped=true"
import script from "./select_modules.vue?vue&type=script&lang=js"
export * from "./select_modules.vue?vue&type=script&lang=js"
import style0 from "./select_modules.vue?vue&type=style&index=0&id=006a90c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a90c8",
  null
  
)

export default component.exports